module.exports = __webpack_public_path__ + "static/media/rompelo-todo-min.6d973731.png";